import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logoNew from "../../../assets/logo-new.png";
import logoCollapsed from "../../../assets/logo-collapsed.png";
import { useNavigate } from "react-router-dom";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

const Sidebar = ({
  tabs,
  setTabs,
  selectedTab,
  selectedSubTab,
  setSelectedTab,
  setSelectedSubTab,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [activeTab, setActiveTab] = useState("");
  const [activeSubTab, setActiveSubTab] = useState("");
  const navigate = useNavigate();

  const toggleCollapse = () => setIsCollapsed(!isCollapsed);

  const handleTabClick = (label, e) => {
    e.preventDefault();
    const tab = tabs.find((tab) => tab.name === label);
    if (tab.subTabs.length > 0) {
      setActiveTab(activeTab !== label ? label : "");
      if (activeTab === label) {
        setActiveSubTab("");
      }
    } else {
      setActiveTab(label);
      setSelectedTab(label);
      navigate(tab.path);
    }
  };

  const handleLogout = () => {
    navigate("/logout");
  };
  const handleProfile = () => {
    navigate("/profile");
  };

  const renderTooltip = (props, text) => (
    <Tooltip id="button-tooltip" {...props}>
      {text}
    </Tooltip>
  );

  const handleSubTabClick = (label, subTab, e) => {
    e.preventDefault();
    setSelectedTab(activeTab);
    setSelectedSubTab(subTab.name);
    setActiveSubTab(label);
    navigate(subTab.path);
  };

  return (
    <div
      className={`d-flex flex-column rounded bg-custom overflow-auto sidebar ${
        isCollapsed ? "sidebar-collapsed" : ""
      }`}
      style={{
        height: "100%",
        width: isCollapsed ? "75px" : "200px",
        transition: "width 0.4s",
      }}
    >
      <div className="navbar-brand mt-2 mt-lg-0 mb-2 p-2 text-center ">
        <a href="/home">
          <img
            src={isCollapsed ? logoCollapsed : logoNew}
            height="50"
            alt="Emalpha Logo"
            className="img-fluid"
          />
        </a>
      </div>
      <div className="sidebar-header border-bottom d-flex justify-content-end p-1 mb-2">
        <OverlayTrigger
              placement="right"
              overlay={(props) => renderTooltip(props, `${isCollapsed ? "Expand" : "Collapse"}`)}
            >
        <div className="rounded-5 border mb-2">
          <button className="btn" onClick={toggleCollapse}>
            <i
              className={`fa-solid ${
                isCollapsed ? "fa-angles-right" : "fa-angles-left"
              } fa-lg`}
            />
          </button>

        </div>
          </OverlayTrigger>
      </div>

      <ul className="nav nav-pills flex-col mb-auto text-truncate">
        {tabs.map((tab) => (
          <React.Fragment key={tab.name}>
            <OverlayTrigger
              placement="right"
              overlay={(props) => renderTooltip(props, tab.name)}
            >
              <li
                className={`nav-item mb-3 w-100 ${
                  !(activeTab === tab.name) ? "border-bottom" : ""
                }`}
              >
                <a
                  href={tab.path}
                  className={`nav-link black-text-link ${
                    activeTab === tab.name && activeSubTab === ""
                      ? "active"
                      : ""
                  }`}
                  onClick={(e) => handleTabClick(tab.name, e)}
                  style={{ cursor: "pointer" }}
                >
                  {tab.image ? (
                    <img
                      src={tab.image}
                      alt={tab.name}
                      className=""
                      style={{ width: "44px" }}
                    />
                  ) : (
                    <i className={`fa-solid fa-lg ${tab.icon} m-2`} />
                  )}
                  {!isCollapsed && tab.name}
                </a>
              </li>
            </OverlayTrigger>
            {tab.subTabs && activeTab === tab.name && (
              <ul className="nav flex-col ms-2 border-bottom">
                {tab.subTabs.map((subTab) => (
                  <OverlayTrigger
                    placement="right"
                    overlay={(props) => renderTooltip(props, subTab.name)}
                    key={`${tab.name}-${subTab.name}`}
                  >
                    <li key={subTab.name} className="nav-item">
                      <a
                        href={`${tab.path}/${subTab.path}`}
                        className={`nav-link black-text-link ${
                          activeSubTab === subTab.name ? "active" : ""
                        }`}
                        onClick={(e) =>
                          handleSubTabClick(subTab.name, subTab, e)
                        }
                        style={{
                          overflow: "hidden",
                          maxWidth: "100%",
                          whiteSpace: "nowrap",
                          textOverflow: "ellipsis",
                          display: "inline-block",
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                      >
                        {subTab.image ? (
                          <img
                            src={subTab.image}
                            alt={subTab.name}
                            className="m-2"
                            style={{ width: "26px" }}
                          />
                        ) : (
                          <i
                            className={`fa-solid fa-xl ${subTab.icon} m-2 px-1`}
                          />
                        )}
                        {!isCollapsed && subTab.name}
                      </a>
                    </li>
                  </OverlayTrigger>
                ))}
              </ul>
            )}
          </React.Fragment>
        ))}
      </ul>

      <div className="sidebar-header border-top d-flex justify-content-start align-content-end ms-2 mt-auto">
        <div className="flex flex-col">
          <div>
          <OverlayTrigger
              placement="right"
              overlay={(props) => renderTooltip(props, "Logout")}
            >
            <button className="btn black-text-link" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt fa-lg" />{" "}
              {!isCollapsed && "Logout"}
            </button>
            </OverlayTrigger>
          </div>
          <div className="border-bottom">
          <OverlayTrigger
              placement="right"
              overlay={(props) => renderTooltip(props, "Profile")}
            >
            <button className="btn black-text-link" onClick={handleProfile}>
              <i className="fas fa-user fa-lg" /> {!isCollapsed && "Profile"}
            </button>
            </OverlayTrigger>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
